<template>
    <v-container class="grey lighten-5 title-bar">
        <v-row no-gutters>
            <v-col :cols="8">
                <slot name="sub-title"></slot>
            </v-col>
            <v-col :cols="4">
                <p class="title-bar__help-box text-right">
                    {{$t('global-terms.need-help')}}
                    <br>
                    {{$t('global-terms.call-us')}} +44 (0)117 204 7810
                    <br>
                    <a href="https://help.sawdays.co.uk/" target="_BLANK" class="user-guides-link" :title="$t('global-terms.user-guides-faqs')">
                        &raquo; {{$t('global-terms.user-guides-faqs')}}
                    </a>
                </p>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
  name: 'sub-title-bar',
}
</script>
<style lang="scss" scoped>
.user-guides-link {
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
</style>
